
import { computed, defineComponent, getCurrentInstance, onMounted, ref } from 'vue';
import MarkdownIt from 'markdown-it';
import { UserInfoByLogin } from '@/api/user';

const MessageTextMD = defineComponent({
    components: {},
    props: {
        content: {
            type: String,
            default: undefined,
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const { yellowfont } = proxy?.$store?.state?.abTestModule?.abTestParams;
        const md = ref<any>(null);

        const userInfoByLogin = computed<UserInfoByLogin>(() => {
            const userInfoByLogin = (proxy?.$store?.state?.userModule?.userInfo || {}) as UserInfoByLogin;
            return userInfoByLogin;
        });
        const userName = computed(() => {
            const { user } = userInfoByLogin.value || {};
            return user?.user_name || '';
        });
        const processContent = (str: string, botName: string = ''): string => {
            if (!str) return '';
            let result = str;
            // 1. 移除 {{user}} 及其后面的逗号
            result = result.replace(/(?:\{\{user\}\}|\{user\}),?/g, userName.value);
            // 2. 替换 {{char}} 为机器人名称
            result = result.replace(/\{\{char\}\}/g, botName);
            // 3. 处理 LaTeX 公式
            // 把 \[...\] 转换为 $$...$$，并清理多余空格
            result = result.replace(/\\\[([\s\S]*?)\\\]/g, (_, p1) => {
                // 清理公式内多余的空格：保留必要空格，去除首尾和多余空格
                const cleanFormula = p1.trim().replace(/\s+/g, ' ');
                return `$$${cleanFormula}$$`;
            });
            // 把 \(...\) 转换为 $...$，并清理多余空格
            result = result.replace(/\\\(([\s\S]*?)\\\)/g, (_, p1) => {
                const cleanFormula = p1.trim().replace(/\s+/g, ' ');
                return `$${cleanFormula}$`;
            });
            // 4. 清理多余空格和处理换行
            result = result
                .split('\n')
                .map(line => line.trim())
                .join('\n');

            return result;
        };

        const markdownStyle = computed(() => {
            return {
                '--markdown-font-color': yellowfont ? '#c89349' : '#d3d0d0',
                '--markdown-em-font-style': yellowfont ? 'italic' : 'normal',
            };
        });

        const renderedContent = computed(() => {
            if (!md.value) return '';
            return md.value.render(processContent(props.content));
        });

        // viewer 配置选项
        const viewerOptions = {
            inline: false,
            button: true,
            navbar: true,
            title: false,
            toolbar: {
                zoomIn: true,
                zoomOut: true,
                oneToOne: true,
                reset: true,
                prev: false,
                next: false,
                rotateLeft: true,
                rotateRight: true,
                flipHorizontal: true,
                flipVertical: true,
            },
            tooltip: true,
            movable: true,
            zoomable: true,
            rotatable: true,
            scalable: true,
            transition: true,
            fullscreen: true,
            keyboard: true,
            hidden: (e: CustomEvent) => {
                // 预览隐藏后的回调
                const viewers = document.querySelectorAll('.el-image-viewer__wrapper');
                viewers.forEach(el => el.remove());
            },
        };

        onMounted(async () => {
            if (process.client) {
                md.value = new MarkdownIt({
                    html: true,
                    linkify: true,
                    typographer: true,
                    breaks: true,
                });

                const mdcontainer = document.querySelector('.md-viewer-container');
                mdcontainer?.addEventListener('click', e => {
                    const target = e.target as HTMLElement;
                    let isDetail = false;
                    if (target.closest('details') || target.closest('summary')) {
                        isDetail = true;
                    }
                    if (e.target instanceof HTMLImageElement || e.target instanceof HTMLAnchorElement || isDetail) {
                        e.stopPropagation();
                    }
                });
            }
        });
        return { renderedContent, viewerOptions, markdownStyle };
    },
});

export default MessageTextMD;
